var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsLoaderArc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M16 0v2.91C8.77 2.91 2.91 8.77 2.91 16c0 7.23 5.86 13.09 13.09 13.09 7.23 0 13.09-5.86 13.09-13.09 0-2.067-.478-4.022-1.331-5.76l2.489-1.528C31.368 10.898 32 13.375 32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLoaderArc);
export default __webpack_public_path__ + "static/media/icons-loader-arc.50b839948717e9b7a09add961c5a8a55.svg";
export { ForwardRef as ReactComponent };